import { Button } from '@cian/ui-kit';
import { IconActionCompareAdd16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

interface IComparisonButtonProps {
  onClick(): void;
  disabled: boolean;
}

export const ComparisonButton: React.FC<IComparisonButtonProps> = ({ onClick, disabled }) => {
  return (
    <Button
      size="XS"
      theme="fill_secondary"
      data-mark="ComparisonControl"
      onClick={onClick}
      beforeIcon={<IconActionCompareAdd16 color={disabled ? 'gray60_100' : 'icon-main-default'} />}
      disabled={disabled}
    />
  );
};
